<template>
  <div class="student-statistic">
    <div class="statistic-head" v-if="titleNumber !== '1'">
      <div class="statistic-head__num">{{titleNumber}}</div>
      <div class="statistic-head__title">{{titleName}}</div>
    </div>
    <ul class="statistic-list">
        <li class="statistic-list__item"  v-for="(item,index) in statisticList"
        :key="`item_${index}`">
          <div class="item-title">
            {{item.title}}
             <el-popover
              placement="top"
              title="说明"
              width="200"
              trigger="hover"
              :content="item.content"
              v-if="item.id<4||item.id===6"
              >
              <img slot="reference"
              src="../../images/why-icon.png" class="item-title__tooltip" alt="">
            </el-popover>
          </div>
          <div class="item-num" @click="clickItem(index)">
            {{item.num}}
            <span class="item-unit">{{item.unit}}</span>
          </div>
          <div class="item-detail" >
          {{item.detail || '--'}}
          </div>
        </li>
      </ul>
  </div>
</template>

<script>

export default {
  name: 'ClassRecent',
  props: {
    titleName: {
      type: String,
      default: '学习成果统计',
    },
    titleNumber: {
      type: String,
      default: '01',
    },
    subjectId: {
    },
    studyResults: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      // 理科列表
      scienceList: [
        {
          title: '班级总共测学知识点总个数',
          num: '',
          unit: '个',
          id: 0,
          detail: '人均测学:',
          content: '测学知识点 = 班级内的学生在当前周内测试或学习过的知识点（一个知识点被多人学习多次，会统计多次)',
        },
        {
          title: '班级发现漏洞知识点个数',
          num: '',
          unit: '个',
          id: 1,
          detail: '人均发现:',
          content: '漏洞知识点 = 在测试环节测出的薄弱知识点'
          + '\n\r'
          + '（一个知识点被多人学习多次，会统计多次)',
        },
        // {
        //   title: '班级学完知识点次数',
        //   num: '',
        //   unit: '次',
        //   id: 2,
        //   detail: '人均学完:',
        //   content: '学完知识点 = 在学习环节学完的知识点'
        //   + '\n\r'
        //    + '（一个知识点被多人学习多次，会统计多次)',
        // },
        {
          title: '班级攻克薄弱知识点个数',
          num: '',
          unit: '个',
          id: 3,
          detail: '人均攻克:',
          content: '攻克知识点 = 在学习环节学完且学后掌握的知识点'
          + '\n\r'
          + '（一个知识点被多人学习多次，会统计多次)',
        },
        {
          title: '总答题数', num: '', unit: '道', id: 4,
        },
        {
          title: '平均正确率', num: '', unit: '%', id: 5, detail: '正确占比',
        },
        {
          title: '人均学习时长', num: '', unit: '分钟', id: 6, detail: '人均看视频', content: '总学习时长包含答题、看视频、错题订正、查看解析等',
        },
      ],
      // 语文列表
      chineseList: [
        {
          title: '总答题数', num: '', unit: '道', id: 4,
        },
        {
          title: '主观题平均得分率', num: '', unit: '%', id: 5,
        },
        {
          title: '人均学习时长', num: '', unit: '分钟', id: 6, detail: '人均看视频', content: '总学习时长包含答题、看视频、错题订正、查看解析等',
        },
      ],
      // 英语列表
      englishList: [
        {
          title: '总答题数', num: '', id: 4, unit: '道',
        },
        {
          title: '客观题平均正答率', num: '', id: 5, detail: '人均看视频', unit: '%',
        },
        {
          title: '人均学习时长', num: '', id: 6, detail: '人均看视频', unit: '分钟', content: '总学习时长包含答题、看视频、错题订正、查看解析等',
        },
      ],
    };
  },
  computed: {
    statisticList() {
      // if (this.subjectId === 1) {
      //   return this.englishList;
      // } if (this.subjectId === 3) {
      //   return this.chineseList;
      // }
      return this.scienceList;
    },
  },
  mounted() {
  },
  watch: {
    studyResults() {
      this.initData();
    },
  },
  methods: {
    initData() {
      this.scienceList[0].num = this.studyResults.study_code_num;
      this.scienceList[0].detail = `人均测学: ${this.studyResults.avg_study_code_num < 0 ? 0 : this.studyResults.avg_study_code_num} 次`;
      this.scienceList[1].num = this.studyResults.leak_code_num;
      this.scienceList[1].detail = `人均发现: ${this.studyResults.avg_leak_code_num < 0 ? 0 : this.studyResults.avg_leak_code_num}次`;
      this.scienceList[2].num = this.studyResults.conquer_code_num;
      this.scienceList[2].detail = `人均攻克: ${this.studyResults.avg_conquer_code_num < 0 ? 0 : this.studyResults.avg_conquer_code_num}次`;
      this.scienceList[3].num = this.studyResults.question_num;
      this.scienceList[4].num = this.studyResults.avg_right_rate < 0 ? '--'
        : Math.ceil(this.studyResults.avg_right_rate);
      this.scienceList[4].detail = `正答占比： ${this.studyResults.right_num}
        / ${this.studyResults.question_num}道`;
      this.scienceList[5].num = Math.ceil(this.studyResults.avg_study_time);
      this.scienceList[5].detail = `人均看视频${Math.ceil(this.studyResults.avg_study_video_time)}分钟
        练习${Math.ceil(this.studyResults.avg_study_practice_time)}分钟`;
    },
    clickItem(index) {
      this.$emit('clickItem', index);
    },
  },
};
</script>

<style lang="scss" scoped>
.student-statistic{
  padding-top:30px;
  .statistic-head{
    display: flex;
    align-items: center;
    &__num{
      font-size: 22px;

      font-weight: bold;
      color: rgba(0, 0, 0, 0.8);
      margin-right: 14px;
      background:url('~@/views/pt/images/class_bg.png');
      background-size:cover;
      width:38px;
      height:29px;
      text-align: center;

    }
    &__title{
      font-size: 17px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.8);

    }
  }
  .statistic-list{
    display: flex;
    flex-flow: wrap;
    margin-top:30px;
    &__item{
      width: 242px;
      height: 156px;
      background: #F0F2F8;
      border-radius: 12px;
      margin: 0 15px 24px 0;
      .item-title{
        font-size: 16px;
        text-align: center;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #808BAA;
        padding-top: 24px;

         &__tooltip {
          display: inline-block;
          width: 16px;
          height: 16px;
          text-align: center;
          vertical-align:text-bottom;
        }
      }
      .item-num{
        font-size: 36px;
        text-align: center;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 500;
        padding-top: 15px;
        color: #1989FA;
        cursor: pointer;
        .item-unit{
          font-size: 24px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 500;
          color: #586077;
        }
      }
      .item-detail{
        font-size: 14px;
        padding-top: 5px;
        text-align: center;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 400;
        color: rgba(48, 49, 51, 0.6);
      }
    }
  }
}

</style>
